import { Specialization } from '@docbay/schemas';
import axiosInstance from 'integration/api/axiosInstance';

/**
 * API methods for fetching specializations.
 */
export const SpecializationsAPI = {
  /**
   * Fetches a list of all specializations.
   *
   * @returns A promise that resolves to an array of Specialization objects.
   */
  fetchSpecializations: () =>
    axiosInstance.get<Specialization[]>('/specializations'),

  /**
   * Fetches a single specialization by its ID.
   *
   * @param id - The ID of the specialization to fetch.
   * @returns A promise that resolves to a Specialization object.
   */
  fetchSpecializationsById: (id: string) =>
    axiosInstance.get<Specialization>(`/specializations/${id}`),
};
